import { useLocation } from 'react-router-dom';
import HeaderWithBackButton from 'app/components/HeaderWithBackButton';
import PageLoader from 'app/components/PageLoader';
import Search from 'app/components/search';
import { APP_CONSTANTS } from 'app/constants/app-constants';
import useLeaderboard from './useLeaderboard';

const Leaderboard = () => {
  const { state } = useLocation();
  const gameId = state?.id;
  const gameTitle = state?.title;

  const {
    rows,
    totalCount,
    pageNumber,
    pageSize,
    pageLoading,
    searchTerm,
    setSearchTerm,
    goToPage,
  } = useLeaderboard(gameId);

  const pageCount = Math.ceil(totalCount / pageSize);
  const startIndex = (pageNumber - 1) * pageSize + 1;
  const endIndex = Math.min(pageNumber * pageSize, totalCount);

  return (
    <div className='blogsForm'>
      <div className='blogsForm_content'>
        <HeaderWithBackButton
          title={`Leaderboard${gameTitle ? ` - ${gameTitle}` : ''}`}
          goTo={APP_CONSTANTS.GAME_MANAGEMENT}
        />

        {!gameId ? (
          <div className='wd-100'>
            <p>
              No game selected. Open a game's edit screen and click "View
              Leaderboard" to view its rankings.
            </p>
          </div>
        ) : (
          <>
            <div className='d-flex justify-content-between align-items-center flex-wrap mb-3'>
              <div className='content-container__filterSearch'>
                <Search
                  placeholder='Search by customer name'
                  value={searchTerm}
                  onChange={setSearchTerm}
                />
              </div>
            </div>
            <div className='table-wrapper'>
              <div className='table'>
                <table className='my-table'>
                  <thead>
                    <tr>
                      <th>Rank</th>
                      <th>Customer</th>
                      <th>Best Score</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length === 0 ? (
                      <tr>
                        <td colSpan='3'>
                          <div className='bottom-pagination'>
                            <span className='content-container__pagination'>
                              {searchTerm.trim()
                                ? 'No matching customers found'
                                : 'No Data Found'}
                            </span>
                          </div>
                        </td>
                      </tr>
                    ) : (
                      rows.map((row) => (
                        <tr key={`${row.rank}-${row.customerId}`}>
                          <td>{row.rank}</td>
                          <td>{row.customerName}</td>
                          <td>{row.bestScore}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
            {totalCount > 0 && (
              <div className='bottom-pagination'>
                <span className='content-container__pagination__left'>
                  Showing {startIndex} - {endIndex} of {totalCount}{' '}
                  {totalCount === 1 ? 'result' : 'results'}
                </span>
                {pageCount > 1 && (
                  <span className='content-container__pagination'>
                    <ul className='pagination'>
                      <li
                        className={`page-item ${
                          pageNumber <= 1 ? 'inactive' : 'cursor-pointer'
                        }`}
                        onClick={() => {
                          if (pageNumber > 1) {
                            goToPage(pageNumber - 1);
                          }
                        }}
                      >
                        <span className='page-link'>&lt;</span>
                      </li>
                      <li className='page-item'>
                        <span className='page-link'>
                          Page {pageNumber} of {pageCount}
                        </span>
                      </li>
                      <li
                        className={`page-item ${
                          pageNumber >= pageCount
                            ? 'inactive'
                            : 'cursor-pointer'
                        }`}
                        onClick={() => {
                          if (pageNumber < pageCount) {
                            goToPage(pageNumber + 1);
                          }
                        }}
                      >
                        <span className='page-link'>&gt;</span>
                      </li>
                    </ul>
                  </span>
                )}
              </div>
            )}
          </>
        )}
      </div>
      {pageLoading && <PageLoader pageLoading={pageLoading} />}
    </div>
  );
};

export default Leaderboard;
